import { useContext } from "react";
import { ReactReduxContext } from "react-redux";
import styled from "styled-components";
import LayerMetadataButton from "../LayerMetadataButton";
import { useAppSelector } from "../../../../state/hooks";
import LayerlistSwitch from "../LayerlistSwitch";
import { setSelectedCustomFilterLayers } from '../../../../state/slices/uiSlice';

const StyledLayerContainer = styled.div`
  background-color: ${(props) => props.themeStyle && '#F5F5F5'};
  overflow: hidden;
  min-height: 32px;
  display: flex;
  align-items: center;
  margin-top: ${(props) => props.themeStyle && '8px'};
  border-radius: 4px;
  margin-bottom: 4px;
`;

const StyledlayerHeader = styled.div`
  margin-right: 0.5em;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

const StyledLayerName = styled.p`
  word-break: break-word;
  user-select: none;
  color: ${(props) =>
    props.themeStyle
      ? props.theme.colors.secondaryColorGreen
      : props.theme.colors.mainColor1};
  margin: 0px;
  font-size: 14px;
  padding-left: 8px;
`;

export const FilterLayer = ({ layer, theme, groupName }) => {
  const { store } = useContext(ReactReduxContext);
  const selectedCustomFilterLayers = useAppSelector(
    (state) => state.ui.selectedCustomFilterLayers
  );

  const excludeGroups = ['Digiroad', 'Tierekisteri (Poistuva)'];

  const handleLayerSelect = (layer) => {
    // lisää valitut tasot väliaikaiseen arrayhyn
    if (
      selectedCustomFilterLayers.filter(
        (selectedLayer) => selectedLayer.id === layer.id
      ).length > 0
    ) {
      const filteredLayers = selectedCustomFilterLayers.filter(
        (filterLayer) => filterLayer.id !== layer.id
      );
      store.dispatch(setSelectedCustomFilterLayers(filteredLayers));
    } else {
      store.dispatch(
        setSelectedCustomFilterLayers([...selectedCustomFilterLayers, layer])
      );
    }
  };

  const themeStyle = theme || null;

  const isSelected =
    selectedCustomFilterLayers.filter(
      (selectedLayer) => selectedLayer.id === layer.id
    ).length > 0;

  return (
    <StyledLayerContainer
      themeStyle={themeStyle}
      className={`list-layer ${layer.visible && 'list-layer-active'}`}
      key={'layer' + layer.id + '_' + theme}
    >
      <StyledlayerHeader>
        <StyledLayerName themeStyle={themeStyle}>
          {layer.name}{' '}
          {groupName &&
            groupName !== 'Unknown' &&
            !excludeGroups.includes(groupName) &&
            ` (${groupName})`}
        </StyledLayerName>
      </StyledlayerHeader>
      {layer.metadataIdentifier && <LayerMetadataButton layer={layer} />}
        <LayerlistSwitch
          action={() => handleLayerSelect(layer)}
          isSelected={isSelected}
          layer={layer}
        />
    </StyledLayerContainer>
  );
};

export default FilterLayer;
